import React from "react";
import Chart from "react-apexcharts";

export default function Dispatchissue() {
  const state = {
    stroke: {
      lineCap: "round",
    },
    options: {
      dataLabels: {
        enabled: false,
      },
      legend: {
        fontSize: "16px",
        fontWeight: "700",
        fontFamily: "Poppins",
        position: "right",
        horizontalAlign: "center",
        // labels: {
        //   show: true,
        //   name: "Total Issus",
        //   value: 263,
        // },
      },

      title: {
        text: "125",
        align: "center",
        margin: 10,
        offsetX: -55,
        offsetY: 115,
        floating: false,
        style: {
          fontSize: "24px",
          fontWeight: "bold",
          color: "#000",
        },
      },
      subtitle: {
        text: "Items",
        align: "center",
        margin: 10,
        offsetX: -55,
        offsetY: 145,
        floating: false,
        style: {
          fontSize: "16px",
          fontWeight: "300",
          color: "#000",
        },
      },
      // subtitle: {
      //   text: ,
      //   align: "center",
      //   margin: 10,
      //   offsetX: 0,
      //   offsetY: 105,
      //   floating: false,
      //   style: {
      //     fontSize: "14px",
      //     fontWeight: "bold",
      //     color: "#000",
      //   },
      // },
      labels: ["Damaged", "Faulty", "Missing"],
      colors: ["#FF0000", "#FFFF00", "#00FF00"],

      plotOptions: {
        pie: {
          customScale: 1,
          donut: {
            size: "83%",
            // labels: {
            //   show: true,
            //   name: "Total Issus",
            //   value: 263,
            // },
          },
        },
      },
    },

    series: [45, 35, 20],
  };
  return (
    <div>
      <div class="mt-8">
        <div class=" shadow-slate-400 shadow-md bg-white rounded-lg flex-1">
          <div className="flex flex-wrap mr-4 pt-2">
            <h3 className="text-xl font-bold ml-6"> Despatch Issues</h3>
          </div>
          <div className="flex flex-wrap pb-2">
            <div className="flex-1 flex-wrap ">
              <Chart
                // className="sm:w-32"
                //@ts-ignore
                options={state.options}
                series={state.series}
                type="donut"
                width="380"
              />
            </div>
            <div className="flex-2 md:overflow-x-auto overflow-x-auto  float-right ml-auto mr-4 mt-1">
              <div className="flex p-2 -mt-2">
                <div className=" text-center w-fit align-middle  cursor-pointer pb-2">
                  <div className="flex">
                    <p className="ml-5 font-bold  text-red-700"> A Grade</p>
                  </div>
                  <p className=" text-lg text-black ml-4">496,362 items</p>
                </div>
                <div className=" text-center w-fit align-middle ml-1  cursor-pointer pb-2">
                  <div className="flex ml-5">
                    <p className="ml-5 font-bold  text-yellow">
                      {" "}
                      B Grade
                    </p>{" "}
                  </div>
                  <p className=" text-lg text-black ml-4 pl-4">942,654 items</p>
                </div>
                <div className=" text-center w-fit align-middle ml-6  cursor-pointer pb-2">
                  <div className="flex ml-5">
                    <p className="ml-5 font-bold  text-green-500">
                      {" "}
                      C Grade
                    </p>{" "}
                  </div>
                  <p className=" text-lg text-black ml-4 pl-4">654,485 items</p>
                </div>
              </div>
              <div class="relative pt-1 px-12 mt-2">
                <div className="flex text-lg ">
                  <p className="font-bold text-2xl ml-2 mr-3">594 </p> Total
                </div>
                <div class="overflow-hidden h-6 mb-4 text-xs flex rounded-2xl bg-cyan-200">
                  <div
                    style={{ width: "30%" }}
                    class="shadow-none rounded-xl flex flex-col text-center whitespace-nowrap text-white justify-center bg-red-500"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
